import { FC, useCallback, useState } from 'react';
import modalClasses from '../../asset/css/common-modal.module.css';
import { CommonModal } from '../CommonModal';
import {MessageContentType} from "../../types/message-content-type";

export const MessageModal: FC<{
  active: boolean;
  scrollOffset: number;
  closeFunc: () => void;
  messageContent?: MessageContentType;
}> = ({ active, scrollOffset, closeFunc, messageContent }) => {
  const closeBtnClickHandler = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  const content = (
    <>
      <h2>{messageContent?.title ?? ''}</h2>
      <p>{messageContent?.body ?? ''}</p>
      <button type="button" className={modalClasses.mypage_popup_ok} onClick={closeBtnClickHandler}>
        OK
      </button>
    </>
  );

  return <CommonModal active={active} scrollOffset={scrollOffset} closeFunc={closeFunc} content={content} />;
};
